// sections/page-faqs.liquid — scoped behavior.
// Loaded only when the section has "Category heading" blocks.
(function () {
  var tabs = document.querySelectorAll('[data-faq-tab]');
  var categories = document.querySelectorAll('[data-faq-category]');

  if (!tabs.length || !categories.length) return;

  // --- Category filtering: clicking a tab shows only that category's questions. ---
  function showCategory(id) {
    tabs.forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-faq-tab') === id);
    });

    categories.forEach(function (category) {
      category.classList.toggle('is-active', category.getAttribute('data-faq-category') === id);
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (event) {
      event.preventDefault();
      showCategory(tab.getAttribute('data-faq-tab'));
    });
  });

  // --- Prev/next arrows: only shown when the tab row actually overflows. ---
  var wrap = document.querySelector('[data-faqs-tabs-wrap]');
  var track = document.querySelector('[data-faqs-tabs]');
  var prevBtn = document.querySelector('[data-faqs-tabs-prev]');
  var nextBtn = document.querySelector('[data-faqs-tabs-next]');

  if (wrap && track && prevBtn && nextBtn) {
    var SCROLL_STEP = 160;

    function updateArrows() {
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;

      if (!hasOverflow) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        return;
      }

      prevBtn.hidden = track.scrollLeft <= 0;
      nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -SCROLL_STEP, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: SCROLL_STEP, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }
})();